/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 */
import {
    downloadActionFile, EMPTY_VALUES,
    getDateFormat,
} from "../../../../../Apis/functions";
import {getFileIcon, getFileNameWithoutExtension} from "../../../../../Helpers/fileType";
import CustomFileCard from "../../../../../components/CustomFileCard";
import {
    EmailSubsectionChip,
    IconMaterialType,
    PhoneSubsectionChip
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import React from "react";
import {getUnitTransByName} from "../../../Dining/Ingredients/Model/Models";

const MaterialApprovalCard = ({styles, data, t}) => {

    return (
        <>
            <div className={"d-flex justify-content-start mt-3"}>
                <div style={styles.container}>
                    <div style={styles.levelCard}>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p className={"ibl-font-w-600 fs-14px"}>{t('material_control')} </p>
                        </div>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <p className={"fs-14px"}>{data?.code} | {data?.title}</p>
                        </div>
                    </div>

                    <div className={"col-12 mt-3"}>
                        <div className={"p-16px background-shades-50 border-radius-8px border-full-shades-300 d-flex flex-column"}>

                            <p className={"fs-20px ibl-font-w-600 justify-content-start d-flex "}>{t('general_details')} </p>

                            <div className={"row pl-20 pr-20"}>
                                <div className="col-sm-12 col-md-6 d-flex flex-column justify-content-start gap-2 mt-24px">
                                    <p style={styles.title}>{t("request_title")}</p>

                                    <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                        {data?.title}
                                    </p>
                                </div>
                                <div className="col-6 d-flex flex-column justify-content-start gap-2 mt-24px">
                                    <p style={styles.title}>{t("folio")}</p>

                                    <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                        {data?.code}
                                    </p>
                                </div>

                                <div className={"col-12 mt-24px"}>
                                    <p style={styles.title}>{t("requested_by")}</p>
                                </div>

                                <div className='col-12 mt-2'>
                                    <div className={"d-flex justify-content-between gap-3 background-general-00 border-radius-4px p-2"}>
                                        <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                            {data?.requestedBy}
                                        </p>
                                        <div className="d-flex align-items-center">
                                            <div className={"d-flex"}><EmailSubsectionChip className="mr-8px mb-1" /></div>
                                            <div className={"flex-grow-1 minw-0 p-0 m-0"}>
                                                <CustomTooltip
                                                    text={data?.requestedByEmail}
                                                    classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                    showIfTruncated={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className={"d-flex"}><PhoneSubsectionChip className="mr-8px mb-1" /></div>
                                            <p className="fs-14px font-color-general-950">{data?.requestedByPhoneNumber || EMPTY_VALUES.DEFAULT}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 d-flex flex-column gap-2 mt-24px">
                                    <p style={styles.title}>{t("vehicle_information")}</p>

                                    <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                        {data?.vehicleInformation || EMPTY_VALUES.DEFAULT}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className={"col-12 mt-3"}>
                        <div className={"p-16px background-shades-50 border-radius-8px border-full-shades-300 d-flex flex-column"}>
                            <p className={"fs-20px ibl-font-w-600 justify-content-start d-flex "}>{t('materials')} </p>
                            <div className={"row pl-20 pr-20"}>
                                {data?.items?.map((item) => {
                                    return (
                                        <>
                                            <div className={"d-flex justify-content-between background-general-00 border-radius-4px pl-3 pr-2 py-3 mb-3"}>
                                                <p className="justify-content-start d-flex ibl-font-w-600 fs-14px">
                                                    {item?.name}
                                                </p>
                                                <div className="d-flex align-items-center">
                                                    <div className={"d-flex"}><IconMaterialType className="mr-8px icon-color-shades-800"/></div>
                                                    <div className={"flex-grow-1 minw-0 w-100px"}>
                                                        <CustomTooltip
                                                            text={`${item?.quantity} ${t(getUnitTransByName(item?.measurementUnitName))}`}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                            showIfTruncated={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>


                    <div className={"col-12 mt-3 mb-60px"}>
                        {
                            data?.evidence?.map((item) => {
                                const file = item?.fileSelected;
                                const title = getFileNameWithoutExtension( (file?.name));
                                return (
                                    <div className={"mb-3"}>
                                        <CustomFileCard
                                            classes={"border-0"}
                                            classContent={"background-shades-50 border-radius-8px border-full-shades-300"}
                                            Icon={getFileIcon(file)}
                                            title={title}
                                            fileValue={file}
                                            subtitle={
                                                <p className={"justify-content-start d-flex ibl-font-w-400 fs-12px"}>
                                                    {t('uploaded')}: {getDateFormat(data?.createdAt)}
                                                </p>
                                            }
                                            showChip={false}
                                            buttonId={"btn_mrc_download_" + item.id}
                                            onClick={() => downloadActionFile(file?.url)}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )

}

export default MaterialApprovalCard
